import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, state } = useLocation();
  useEffect(() => {
    // If we're navigating to a specific section, let the target page handle scrolling
    if (state && state.scrollTo) return;
    const lenis = typeof window !== "undefined" ? window.__lenis : null;
    if (lenis && typeof lenis.scrollTo === "function") {
      lenis.scrollTo(0, { immediate: true, force: true });
    }
    // Also force native scroll to top in case Lenis is not yet mounted
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, state]);
  return null;
}
